import React from 'react';
import { HyperdbForm } from '../../../../hyperdb';
import Form from '../components/Form';

export default HyperdbForm(Form, {
  namespace: 'checkInOutRuleset',
  mountedUrl: '/daily-rental/check-in-out-rulesets',
  titleNew: 'Create check in/out ruleset',
  titleEdit: 'Edit check in/out ruleset',
  displayName: (o, props) => o.name,
  checkIsValid: (props) => !!props.objectData.name,
});



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/check-in-out-ruleset/containers/Form.jsx